"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
/**
 * Base function to get req id and fleet pricing
 * Call this function from fleet price store
 * @param {SearchRequestIdParamType} reqParam
 * @returns {Promise}
 */
const getFleetPricing = (reqParam) => __awaiter(void 0, void 0, void 0, function* () {
    const requestId = 'SEARCH_RESULT';
    const config = {
        data: reqParam,
    };
    return http_service_1.default
        .put(requestId, ENDPOINTS_1.default.TARIFF_SERVICE.PRICE_V3, config)
        .then((resData) => resData.data);
});
exports.default = getFleetPricing;
